'use strict';

var constants = require('./constants');
var validation = require('./validation');
var messages = require('./messages.json');
var addressFields = constants.fields;
var addressOptionalFields = constants.optionalFields;

function getOptionalFields (options) {
    var optionalFields = [];
    if (!options.isCountryUS) {
        optionalFields.push(constants.FIELDS.FIELD_STATE);
    }
    if (!options.isPhoneRequired) {
        optionalFields.push(constants.FIELDS.FIELD_PHONE_NUMBER);
    }
    return addressOptionalFields.concat(optionalFields);
}

function getErrorMessage (field, address, options) {
    var value = address[field];
    var isRequired = !getOptionalFields(options).includes(field);
    var validationRules = validation.rules[field] ? validation.rules[field](address, options) : [];
    var failedRules = !!value ? validationRules.filter(function(rule) {
        return !rule.isValid;
    }) : [];

    return failedRules.length ?
        failedRules[0].message :
        isRequired && !value && messages.required;
}

/**
 * Return an Object with two properties: errors and isValid:
 * errors (Object): field name and error message (Example -> { firstName: "Required field", line1: "Item may not ship to PO Box" })
 * isValid (Boolean): check if the address has any errors
 * @param address (Object): field names and values
 * @param options (Object): can except one of the following keys:
 * fields (Array) - custom list of fields to validate
 * allowPOBox (Boolean) - default: false
 * allowLongUSZipCode (Boolean) - default: true
 * isPhoneRequired (Boolean) - default: true
 */
function validate (_address, _options) {
    var address = _address || {};
    var options = Object.assign({}, validation.defaultOptions, _options || {}, {
        isCountryUS: address.country === 'US'
    });
    var errors = (options.fields || addressFields).reduce(function(_errors, field) {
        var message = getErrorMessage(field, address, options);
        if (message) {
            _errors[field] = message;
        }
        return _errors;
    }, {});

    return {
        errors: errors,
        isValid: !Object.keys(errors).length
    };
}

module.exports = validate;



//////////////////
// WEBPACK FOOTER
// ./~/dibs-address-validator/index.js
// module id = 842
// module chunks = 4 7 13 14 20